enum LanguageCode {
  EN_US = 'en-us', // US English
  AR_SA = 'ar-sa', // Arabic (Saudi Arabia)
  EN_GB = 'en-gb', // UK English
  FR_CA = 'fr-ca', // Canadian French
  ES_US = 'es-us', // US Spanish
  ZH_CN = 'zh-cn', // Simplified Chinese
  JA_JP = 'ja-jp', // Japanese only has 1 locale
  KO_KR = 'ko-kr', // Korean only has 1 locale
  PT_BR = 'pt-br', // Portuguese (Brazil)
  VI_VN = 'vi-vn', // Vietnamese only has 1 locale
  DE_DE = 'de-de', // German (Germany)
  IT_IT = 'it-it', // Italian (Italy)
}

export { LanguageCode };
